import { Component } from '@angular/core';

@Component({
  selector: 'app-average-pensionable-earnings-sps-info',
  templateUrl: './average-pensionable-earnings-sps-info.component.html',
  styleUrls: ['./average-pensionable-earnings-sps-info.component.scss']
})
export class AveragePensionableEarningsSpsInfoComponent {

}
